/**
 * Shared utility for agent status display across desktop and mobile views.
 * Provides consistent status text and styling.
 */

export type AgentStatusType = 'COMPLETED' | 'PROCESSING' | 'PENDING' | 'ERROR';

export interface StatusDisplay {
  text: string;
  className: string;
}

/**
 * Get display properties for an agent status.
 * @param status - The agent status string
 * @param t - Translation function from useAdminTranslation
 * @returns Status display object with text and className
 */
export const getAgentStatusDisplay = (status: string, t: (key: string) => string): StatusDisplay => {
  switch (status) {
    case 'COMPLETED':
      return {
        text: t('content.agents.status.active'),
        className: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
      };
    case 'PROCESSING':
      return {
        text: t('content.agents.status.processing'),
        className: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200'
      };
    case 'PENDING':
      return {
        text: t('content.agents.status.pending'),
        className: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200'
      };
    case 'ERROR':
      return {
        text: t('content.agents.status.error'),
        className: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
      };
    default:
      return {
        text: t('content.agents.status.unknown'),
        className: 'bg-gray-100 text-gray-800 dark:bg-dark-background dark:text-dark-text'
      };
  }
};
